<h2 mat-dialog-title>{{ data.modalTitle }}</h2>
<mat-dialog-content>
  <glxy-table-container
    [columns]="columns$ | async"
    [dataSource]="dataSource"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize"
    [showSelection]="true"
    [singleSelection]="data.singleSelection || false"
    (selectionChanged)="selectionChanged($event)"
    [fullWidth]="true"
  >
    <glxy-table-content-header
      [showSort]="false"
      [showActions]="false"
      [showFilters]="true"
      [showFiltersOpen]="false"
      [showColumnArrange]="(isMobile$ | async) === false"
      [showFiltersApplied]="(showFiltersApplied$ | async) ?? false"
    >
      <glxy-filter-chips
        [addFiltersHeader]="'TABLE_FILTERS.HEADER' | translateByObjectType: objectType"
        (filtersChanged)="updateFilters($event)"
        filters-area
      ></glxy-filter-chips>
    </glxy-table-content-header>

    <table mat-table>
      <tr mat-header-row *matHeaderRowDef="[]"></tr>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <ng-container *ngIf="!data.singleSelection">
            <glxy-table-selection></glxy-table-selection>
          </ng-container>
        </th>
        <td mat-cell *matCellDef="let row">
          <glxy-table-selection
            [row]="row"
            [preSelectedLockedRows]="preSelectedLockedRow"
            [preSelectedRows]="newSelection"
          ></glxy-table-selection>
        </td>
      </ng-container>
      <tr mat-row *matRowDef="let row; columns: []" [attr.data-testid]="'crm-object-row-' + row.id"></tr>
    </table>
    <glxy-empty-state
      class="empty-table-container"
      *ngIf="showEmptyState$ | async"
      data-testid="crm-objects-table-empty-state"
    >
      <glxy-empty-state-hero>
        <img
          class="empty-state-image"
          src="https://storage.googleapis.com/galaxy-libs-public-images/crm/contacts-empty-state.svg"
          [alt]="'LIST_OBJECTS_TABLE.EMPTY_TABLE.IMAGE_ALT' | translateByObjectType: objectType"
        />
      </glxy-empty-state-hero>
      <glxy-empty-state-title>
        {{ 'LIST_OBJECTS_TABLE.EMPTY_TABLE.HEADER' | translateByObjectType: objectType }}
      </glxy-empty-state-title>
      <p>{{ 'LIST_OBJECTS_TABLE.EMPTY_TABLE.HINT' | translateByObjectType: objectType }}</p>
    </glxy-empty-state>
  </glxy-table-container>
</mat-dialog-content>
<mat-dialog-actions>
  <ng-container *ngIf="data.objectType === 'Contact'">
    <div class="dialog-secondary-actions">
      <button mat-button *ngIf="!data.hideCreateButton" color="primary" style="" (click)="createContactModal()">
        {{ 'ASSOCIATIONS.MODAL.CREATE_NEW_CONTACT' | translate }}
      </button>
    </div>
    <button mat-stroked-button (click)="cancel()">
      {{ 'ACTIONS.CANCEL' | translate }}
    </button>

    <button mat-flat-button color="primary" (click)="saveCompanies()">
      <ng-container *ngIf="selectedRows.length === 0; else selectedRecipients">
        {{ 'ACTIONS.ADD' | translate }}
      </ng-container>
      <ng-template #selectedRecipients>
        <div *ngIf="selectedRows.length === 1; else selectMultiple">
          {{ 'SELECT_MODAL.ONE_SELECTED' | translateByObjectType: objectType }}
        </div>
      </ng-template>
      <ng-template #selectMultiple>
        <div>
          {{
            'SELECT_MODAL.MORE_SELECTED' | translateByObjectType: objectType : { totalSelected: selectedRows.length }
          }}
        </div>
      </ng-template>
    </button>
  </ng-container>
  <ng-container *ngIf="data.objectType === 'Company'">
    <button mat-stroked-button (click)="cancel()">
      {{ 'ACTIONS.CANCEL' | translate }}
    </button>
    <ng-container *ngIf="!hasAssociations; else saveAction">
      <button mat-flat-button color="primary" (click)="selectContacts()">
        <ng-container *ngIf="selectedRows.length === 0; else selectedRecipients">
          {{ 'ACTIONS.ADD' | translate }}
        </ng-container>
      </button>
    </ng-container>
    <ng-template #saveAction>
      <button mat-flat-button color="primary" (click)="save()">
        <ng-container *ngIf="selectedRows.length === 0; else selectedRecipients">
          {{ 'ACTIONS.ADD' | translate }}
        </ng-container>
      </button>
    </ng-template>
  </ng-container>
  <ng-template #selectedRecipients>
    <div *ngIf="selectedRows.length === 1; else selectMultiple">
      {{ 'SELECT_MODAL.ONE_SELECTED' | translateByObjectType: objectType }}
    </div>
  </ng-template>
  <ng-template #selectMultiple>
    <div>
      {{ 'SELECT_MODAL.MORE_SELECTED' | translateByObjectType: objectType : { totalSelected: selectedRows.length } }}
    </div>
  </ng-template>
</mat-dialog-actions>
